// s1 settingsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { logout } from "../../actions/authenActions";

const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const handleError = (err, rejectWithValue) =>
  rejectWithValue(err.response?.data || err.message);

const createPostThunk = (name, url) =>
  createAsyncThunk(name, async (payload, { dispatch, rejectWithValue }) => {
    try {
      const res = await axios.post(`${baseURL}${url}`, payload);
      return res.data;
    } catch (err) {
      if (err.response && err.response.status === 403) dispatch(logout());
      return handleError(err, rejectWithValue);
    }
  });

export const fetchSettings = createPostThunk(
  "s1Settings/fetchSettings",
  "/s1_pathology/api/settings/",
);
export const addKeyword = createPostThunk(
  "s1Settings/addKeyword",
  "/s1_pathology/api/settings/keywords/",
);
export const deleteKeywords = createPostThunk(
  "s1Settings/deleteKeywords",
  "/s1_pathology/api/settings/keywords/delete/",
);
export const activateKeywords = createPostThunk(
  "s1Settings/activateKeywords",
  "/s1_pathology/api/settings/keywords/activate/",
);
export const deactivateKeywords = createPostThunk(
  "s1Settings/deactivateKeywords",
  "/s1_pathology/api/settings/keywords/deactivate/",
);
export const addNhs = createPostThunk(
  "s1Settings/addNhs",
  "/s1_pathology/api/settings/nhs/",
);
export const deleteNhs = createPostThunk(
  "s1Settings/deleteNhs",
  "/s1_pathology/api/settings/nhs/delete/",
);
export const activateNhs = createPostThunk(
  "s1Settings/activateNhs",
  "/s1_pathology/api/settings/nhs/activate/",
);
export const deactivateNhs = createPostThunk(
  "s1Settings/deactivateNhs",
  "/s1_pathology/api/settings/nhs/deactivate/",
);

const settingsSlice = createSlice({
  name: "s1Settings",
  initialState: {
    keywords: [],
    nhsNumbers: [],
    loading: false,
    error: null,
    success: null,
  },
  reducers: {
    clearError(state) {
      state.error = null;
    },
    clearSuccess(state) {
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    const thunks = [
      fetchSettings,
      addKeyword,
      deleteKeywords,
      activateKeywords,
      deactivateKeywords,
      addNhs,
      deleteNhs,
      activateNhs,
      deactivateNhs,
    ];
    thunks.forEach((thunk) => {
      builder
        .addCase(thunk.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(thunk.fulfilled, (state, action) => {
          state.loading = false;
          const message = action.payload?.message || "";
          if (action.type.includes("fetchSettings")) {
            state.error = null;
          } else if (action.payload?.success === false) {
            state.error = message || "Operation failed";
            state.success = null;
          } else {
            state.success = message || "Operation successful";
            state.error = null;
          }
          if (Array.isArray(action.payload?.keywords))
            state.keywords = action.payload.keywords;
          if (Array.isArray(action.payload?.nhs_numbers))
            state.nhsNumbers = action.payload.nhs_numbers;
        })
        .addCase(thunk.rejected, (state, action) => {
          state.loading = false;
          state.error =
            action.payload?.message ||
            action.payload ||
            action.error?.message ||
            "Something went wrong";
          state.success = null;
        });
    });
  },
});

export const { clearError, clearSuccess } = settingsSlice.actions;
export default settingsSlice.reducer;
